import ModuleContent from 'features/shared/layout/content/ModuleContent';
import Header from 'features/shared/layout/header/Header';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import FinancialSettlementDetailSection from 'features/payments/sections/FinancialSettlementDetailSection';

type Props = {
  id: string;
}

const FinancialSettlementDetail = (props: Props) => {
  //translations
  const { t } = useTranslation("shared\\moduleNames");

  const { id } = useParams<Props>();

  return (
    <>
      <Header
        title={t("financialSettlementDetail.title")}
        includeBreadcrumbs
        links={[{ text: t("payments.title"), to: "/payments" }]}
      />
      <ModuleContent>
        <FinancialSettlementDetailSection financialSettlementId={id} />
      </ModuleContent>
    </>
  );
}

export default FinancialSettlementDetail;